import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SchuleFormGroup } from '../../bewerbung-einreichen/bewerbung-einreichen-form-groups';
import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { TrimInputValueDirective } from '../../../../services/form/trim-input-value.directive';
import { Select, SelectChangeEvent } from 'primeng/select';
import { DatePicker } from 'primeng/datepicker';
import { Button } from 'primeng/button';
import { Fieldset } from 'primeng/fieldset';
import { AbschlussTyp } from '../abschluss-typ';

@Component({
  selector: 'app-schule[schuleFormGroup]',
  imports: [ReactiveFormsModule, FloatLabel, InputText, TrimInputValueDirective, Select, DatePicker, Button, Fieldset],
  templateUrl: './schule.component.html',
  styleUrl: './schule.component.scss'
})
export class SchuleComponent {
  @Input()
  public schuleFormGroup!: FormGroup<SchuleFormGroup> | null;

  @Output()
  public remove: EventEmitter<void> = new EventEmitter<void>();

  protected graduations: { value: string; typ: AbschlussTyp }[] = [
    { value: 'Hochschulreife', typ: AbschlussTyp.ABITUR },
    { value: 'Fachhochschulreife', typ: AbschlussTyp.FACHHOCHSCHULREIFE },
    {
      value: 'Fachgebundene Hochschulreife',
      typ: AbschlussTyp.FACHHOCHSCHULREIFE
    },
    {
      value: 'Schulischer Teil der Fachhochschulreife',
      typ: AbschlussTyp.FACHHOCHSCHULREIFE
    },
    {
      value: 'Praktischer Teil der Fachhochschulreife',
      typ: AbschlussTyp.FACHHOCHSCHULREIFE
    },
    { value: 'Realschulabschluss', typ: AbschlussTyp.REALSCHULE },
    { value: 'Erweiterter Hauptschulabschluss', typ: AbschlussTyp.HAUPTSCHULE },
    { value: 'Hauptschulabschluss', typ: AbschlussTyp.HAUPTSCHULE },
    { value: 'Noch in schulischer Ausbildung', typ: AbschlussTyp.KEINER },
    { value: 'Ohne allgemeinen Schulabschluss', typ: AbschlussTyp.KEINER }
  ];

  protected schoolGradChange($event: SelectChangeEvent): void {
    const selected: { value: string; typ: AbschlussTyp } | undefined = this.graduations.find(
      (e: { value: string; typ: AbschlussTyp }): boolean => e.value === $event.value
    );

    if (selected === undefined) {
      return;
    }

    this.schuleFormGroup!.controls.abschlussTyp.setValue(selected.typ);
  }
}
